import { hasClass } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';

/*
 ** <media>: media node
 ** <changeToBtn>: the type of button to be made active
 */
export const changePlayPauseBtn = (media, changeToBtn, id) => {
	const play = document.getElementById(`engt-play-${id}`);
	const pause = document.getElementById(`engt-pause-${id}`);
	if (changeToBtn === 'pause') {
		media.play();
		play.classList.add('engt-hidden');
		pause.classList.remove('engt-hidden');
	} else {
		media.pause();
		pause.classList.add('engt-hidden');
		play.classList.remove('engt-hidden');
	}
};

/*
 ** <per>: percantage progressed
 ** <id>: id of the progress bar
 ** <prefixSel>: prefix selector value
 */
export const updateProgressBar = (per, id, prefixSel) => {
	let stylesh = document.getElementById(`engt-style-${prefixSel}-${id}`);
	const addStyle = stylesh ?? true;
	stylesh = stylesh ?? document.createElement('style');
	stylesh.id = `engt-style-${prefixSel}-${id}`;
	const startColor = id === 'control' ? '#fff' : ENGT_CHAT.get('config.botResponseTextColor');
	const endColor = id === 'control' ? '#403F42' : '#C4C4C4';
	stylesh.textContent = `#${prefixSel}-${id}::-webkit-slider-runnable-track{ background-image: linear-gradient(
				90deg, ${startColor}, ${startColor} ${per}%, ${endColor} ${per}%, ${endColor}) !important}
				#${prefixSel}-${id}::-moz-range-track{ background-image: linear-gradient(
					90deg, ${startColor}, ${startColor} ${per}%, ${endColor} ${per}%, ${endColor}) !important}`;
	addStyle && document.body.appendChild(stylesh);
};

/*
 ** sync video controls between the msg player and the expanded player
 */
export const syncVideoControls = (destVideo, srcVideo, id) => {
	if (srcVideo) {
		srcVideo.pause();
		destVideo.currentTime = srcVideo.currentTime;
		destVideo.playbackRate = srcVideo.playbackRate;
		destVideo.volume = srcVideo.volume;
		document.getElementById(`engtVolProgress-${id}`).value = destVideo.volume;
		document.getElementById(`engtRateText-${id}`).innerHTML = `${destVideo.playbackRate}x`;
	}
	updateProgressBar(destVideo.volume * 100, id, 'engtVolProgress');
	if (!(id !== 'control' && destVideo.currentTime === 0)) {
		changePlayPauseBtn(destVideo, 'pause', id);
	}
};

/*
 ** stop playing media msgs in chat when the popup is being closed/minimized
 */
export const pauseAllMedia = () => {
	document.querySelectorAll('audio').forEach((el) => hasClass(el, 'engt-audio-msg') && el.pause());
	document.querySelectorAll('video').forEach((el) => hasClass(el, 'engt-video-msg') && el.pause());
};
